module.exports = __webpack_public_path__ + "img/AMZPark.896b0dd4.jpg";